function Header () {
    return (
        <header className="bg-gray ">
            <h1 className="text-2xl font-bold py-4 text-white">ed研究所 zenith</h1>

        </header>
    );
}

export default Header ;